import * as React from "react";
import { Container, Grid } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import TextEditor from "../../Editor";
import { convertToEditor } from "../../../utils/helper";
import { bucketURL, showEditIconBlue } from "../../../server/constants";
import OvalBottom from "../../OvalBottom";

const useStyles = makeStyles(() =>
  createStyles({
    f12: {
      fontSize: 12,
    }
  }),
);


function KaiZenIsDifferent(props: any) {
  const classes = useStyles();
  const {
    kaizenDifferent,
    kaizenDifferentDescendantText,
    smartLeverage,
    smartLeverageList,
    moreProtection,
    moreProtectionList,
    moreGrowth,
    moreGrowthList,
    niwStrategy,
    imgEmployeehandshake
  } = props;
  return (
    <div className="sectionPD">
      <OvalBottom direction="left"/>
      <Container maxWidth="lg" className="pdXsScreenNone">
        <Grid container spacing={3} justifyContent="center" alignItems="center" className="colReverse colMarginNone">
          <Grid item xs={12} md={6} className="pdXsScreenNone pdXsScreenBottom">
            <TextEditor content={convertToEditor("Image")}
                        src={`${bucketURL}/${imgEmployeehandshake}`}
                        sectionId={"imgEmployeehandshake"}
                        className="w100 positionR h100"
                        upperDivClass={showEditIconBlue}
            />
          </Grid>
          <Grid item xs={12} md={6} className="pdXsScreen20">

            <TextEditor variant="H3" color="primary" className="title"
                        sectionId={"kaizenDifferent"}
                        content={kaizenDifferent}
                        upperDivClass={showEditIconBlue}/>


            <TextEditor
              className="w100 floatLeft"
              sectionId={"kaizenDifferentDescendantText"}
              content={kaizenDifferentDescendantText}
              upperDivClass={showEditIconBlue}/>

          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} justifyContent="center" className="mt40md">
          <Grid item xs={12} md={4}>

            <TextEditor component="strong" variant="Caption" color="primary"
                        sectionId={"smartLeverage"}
                        content={smartLeverage}
                        upperDivClass={showEditIconBlue}/>


            <TextEditor
              sectionId={"smartLeverageList"}
              content={smartLeverageList}
              upperDivClass={showEditIconBlue}/>


          </Grid>
          <Grid item xs={12} md={4}>

            <TextEditor component="strong" color="primary"
                        sectionId={"moreProtection"}
                        content={moreProtection}
                        upperDivClass={showEditIconBlue}/>


            <TextEditor
              sectionId={"moreProtectionList"}
              content={moreProtectionList}
              upperDivClass={showEditIconBlue}/>


          </Grid>
          <Grid item xs={12} md={4}>

            <TextEditor component="strong" color="primary"
                        sectionId={"moreGrowth"}
                        content={moreGrowth}
                        upperDivClass={showEditIconBlue}/>


            <TextEditor
              sectionId={"moreGrowthList"}
              content={moreGrowthList}
              upperDivClass={showEditIconBlue}/>

          </Grid>
        </Grid>
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={12}>

            <TextEditor align="left" className={" textLightBlack " + " " + classes.f12}
                        sectionId={"niwStrategy"}
                        content={niwStrategy}
                        upperDivClass={showEditIconBlue}/>

          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default KaiZenIsDifferent;
